// apiClient.js — shared axios instance
//
// Why one shared client instead of per-slice `import axios from "axios"`:
//   • Single timeout + retry policy in one place.
//   • Connection reuse (HTTP keep-alive) across the app.
//   • Easy interceptor hook (auth, error reporting, etc.).
// ──────────────────────────────────────────────────────────────────
import axios from "axios";

const apiClient = axios.create({
  timeout: 15000,
  headers: { Accept: "application/json" },
});

export default apiClient;
